import { Chart as ChartJS } from 'chart.js';

// Fix Chart.js v4 tooltip error: "Cannot read properties of null (reading 'getParsed')"
// This happens when the tooltip tries to access elements during data transitions or
// when hovering over chart areas with no data points.
const SafeTooltipPlugin = {
  id: 'safeTooltip',
  beforeEvent(chart, args) {
    const tooltip = chart.tooltip;
    if (!tooltip) return;

    // Patch _getActiveElements to handle null elements gracefully
    if (!tooltip._patched) {
      const original = tooltip._getActiveElements;
      if (original) {
        tooltip._getActiveElements = function (e, lastActive, replay, inChartArea) {
          try {
            return original.call(this, e, lastActive, replay, inChartArea);
          } catch {
            return lastActive || [];
          }
        };
      }
      tooltip._patched = true;
    }
  },
};

ChartJS.register(SafeTooltipPlugin);
